import React from "react";
import "./DestinationSection.css";
import { useNavigate } from "react-router-dom";
import dkashmir from "../../assets/dkashmir.png";
import djaipur from "../../assets/djaipur.png";
import dagra from "../../assets/dagra.png";
import ddelhi from "../../assets/ddelhi.png";
import dshimla from "../../assets/dshimla.png";
import dgoa from "../../assets/dgoa.png";
import { Link } from "react-router-dom";

const DestinationSection = () => {
  const destinations = {
    kashmir: {
      name: "Kashmir",
      image: dkashmir,
      link: "/tour-package-data",
    },
    delhi: {
      name: "Delhi",
      image: ddelhi,
      link: "/tour-package-data",
    },
    shimla: {
      name: "Shimla",
      image: dshimla,
      link: "/tour-package-data",
    },
    jaipur: {
      name: "Jaipur",
      image: djaipur,
      link: "/tour-package-data",
    },
    agra: {
      name: "Agra",
      image: dagra,
      link: "/tour-package-data",
    },
    goa: {
      name: "Goa",
      image: dgoa,
      link: "/tour-package-data",
    },
  };
const navigate=useNavigate()
  return (
    <div className="popular-main">
      {/* header */}
      <div className="popular-header">
        <h1>Popular Destination</h1>
        <Link to="/destination-view-more">
          <button className="view-btn">View More</button>
        </Link>
      </div>

      <div className="popular-layout">
        {/* LEFT */}
        <div className="column">
          <div
            className="cards small"
            onClick={() =>
              navigate(destinations.kashmir.link, {
                state: { title: destinations.kashmir.name },
              })
            }
          >
            <img src={destinations.kashmir.image} alt="" />
            <span>{destinations.kashmir.name}</span>
          </div>

          <div className="row-bottom">
            <div
              className="cards small center-texts"
              onClick={() =>
                navigate(destinations.delhi.link, {
                  state: { title: destinations.delhi.name },
                })
              }
            >
              <img src={destinations.delhi.image} alt="" />
              <span className="small-card-span">{destinations.delhi.name}</span>
            </div>

            <div
              className="cards small center-texts"
              onClick={() =>
                navigate(destinations.shimla.link, {
                  state: { title: destinations.shimla.name },
                })
              }
            >
              <img src={destinations.shimla.image} alt="" />
              <span>{destinations.shimla.name}</span>
            </div>
          </div>
        </div>

        {/* CENTER BIG */}
        <div
          className="cards big"
          onClick={() =>
            navigate(destinations.jaipur.link, {
              state: { title: destinations.jaipur.name },
            })
          }
        >
          <img src={destinations.jaipur.image} alt="" />
          <span>{destinations.jaipur.name}</span>
        </div>

        {/* RIGHT */}
        <div className="column">
          <div
            className="cards small"
            onClick={() =>
              navigate(destinations.agra.link, {
                state: { title: destinations.agra.name },
              })
            }
          >
            <img src={destinations.agra.image} alt="" />
            <span>{destinations.agra.name}</span>
          </div>

          <div
            className="cards small"
            onClick={() =>
              navigate(destinations.goa.link, {
                state: { title: destinations.goa.name },
              })
            }
          >
            <img src={destinations.goa.image} alt="" />
            <span>{destinations.goa.name}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DestinationSection;
